import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3alvarbm: FaireBrandEntity = {
  token: "b_3alvarbm",
  type: "brand",
  name: "Three Bluebirds Swedish Dishcloths",
  avatarUrl:
    "https://cdn.faire.com/fastly/a39668ffd5bdc06f52929ed490d8d374a100f78023d462846e69e29e2499d06b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/689ef8d6f44d2c979394ccae564a55b4737e8f30f89f23aa1caf94accf69ef69.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a39668ffd5bdc06f52929ed490d8d374a100f78023d462846e69e29e2499d06b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/689ef8d6f44d2c979394ccae564a55b4737e8f30f89f23aa1caf94accf69ef69.jpeg",
  location: "Cos Cob, CT, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 1037,
  isTopShop: true,
  isInsider: true,
  description:
    "CLEAN LIFE. GREEN PLANET.\n\nThree Bluebirds creates eco-friendly, compostable Swedish dishcloths that combine style with practical, planet-friendly performance. Proudly family-owned and operated, we design and screen-print each dishcloth in small batches in Connecticut, USA.\n\nMade from FSC-certified cellulose, organic cotton, and non-toxic inks, our reusable dishcloths are a beautiful alternative to paper towels. One cloth absorbs 20x its weight, replaces 17 rolls of paper towels, and lasts 6–9 months—then returns to the earth as compost.\n\nA plastic-free, zero-waste staple for sustainable homes, our dishcloths are dishwasher- and washing machine-safe. Every cloth sold restores 20 gallons of water to nature, and as a 1% for the Planet member, we fund environmental restoration across the U.S.\n\nIdeal as a thoughtful gift, a kitchen refresh, or an easy sustainable switch, Three Bluebirds dishcloths add joy to the everyday and help eco-conscious customers reduce waste—without compromising on style.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:12.340Z",
    importedBy: "entity-db-cli",
  },
};
